// Servicio seguro de HubSpot que usa el backend
// Las API Keys están protegidas en el servidor

import { FormData, Stand } from '../types/stand.types';

// URL del backend (ajusta según tu configuración)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

// Interfaz para la respuesta del backend
interface BackendResponse {
  success: boolean;
  contactId?: string;
  companyId?: string;
  dealId?: string;
  error?: string;
}

// Función para enviar datos al backend de forma segura
const sendToBackend = async (endpoint: string, data: any): Promise<BackendResponse> => {
  try {
    const response = await fetch(`${BACKEND_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Error del servidor: ${response.status}`);
    }

    return await response.json();
  } catch (error: any) {
    console.error(`Error en ${endpoint}:`, error);
    return {
      success: false,
      error: error.message || 'Error de conexión con el servidor'
    };
  }
};

// Función para crear contacto de forma segura
export const createSecureHubSpotContact = async (formData: FormData, selectedStands: Stand[]): Promise<BackendResponse> => {
  return await sendToBackend('/api/hubspot/contact', {
    formData,
    selectedStands
  });
};

// Función para crear empresa de forma segura
export const createSecureHubSpotCompany = async (formData: FormData, selectedStands: Stand[]): Promise<BackendResponse> => {
  return await sendToBackend('/api/hubspot/company', {
    formData,
    selectedStands
  });
};

// Función para crear deal de forma segura
export const createSecureHubSpotDeal = async (formData: FormData, selectedStands: Stand[], contactId: string, companyId: string): Promise<BackendResponse> => {
  return await sendToBackend('/api/hubspot/deal', {
    formData,
    selectedStands,
    contactId,
    companyId
  });
};

// Función para proceso completo de forma segura
export const processSecureHubSpotSubmission = async (formData: FormData, selectedStands: Stand[]): Promise<BackendResponse> => {
  return await sendToBackend('/api/hubspot/complete', {
    formData,
    selectedStands
  });
};

// Función para actualizar contacto de forma segura
export const updateSecureHubSpotContact = async (contactId: string, formData: FormData, selectedStands: Stand[]): Promise<BackendResponse> => {
  return await sendToBackend('/api/hubspot/contact/update', {
    contactId,
    formData,
    selectedStands
  });
};

// Función para actualizar deal de forma segura
export const updateSecureHubSpotDeal = async (dealId: string, formData: FormData, selectedStands: Stand[]): Promise<BackendResponse> => {
  return await sendToBackend('/api/hubspot/deal/update', {
    dealId,
    formData,
    selectedStands
  });
};

// Función para buscar empresa por nombre de forma segura
export const findSecureHubSpotCompanyByName = async (companyName: string): Promise<BackendResponse> => {
  return await sendToBackend('/api/hubspot/company/search', {
    companyName
  });
};
